import {AfterViewInit, Component, HostBinding, inject, OnInit, ViewChild} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import {
  IGridCellEventArgs, IGridEditDoneEventArgs,
  IGridEditEventArgs,
  IgxExcelExporterService,
  IgxGridCell,
  IgxGridStateDirective,
  RowType
} from '@infragistics/igniteui-angular/grids/core';
import {
  IGX_SPLITTER_DIRECTIVES,
  IgxSplitterComponent,
  IgxSplitterPaneComponent
} from '@infragistics/igniteui-angular/splitter';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import {
  IgxButtonDirective,
  IgxButtonModule, IgxFocusDirective,
  IgxRippleDirective,
  IgxRippleModule,
  IgxTextSelectionDirective
} from '@infragistics/igniteui-angular/directives';
import {IGX_INPUT_GROUP_DIRECTIVES, IgxInputGroupComponent} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {ClsConfig} from '../../../util/cls-config';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {TranslateModule} from '@ngx-translate/core';
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {MasOpcionesGridComponent} from "../../util/controles/mas-opciones-grid/mas-opciones-grid.component";
import {ContextMenuGenericoComponent} from "../../util/controles/context-menu-generico/context-menu-generico.component";
import {AppPresupuestosService} from "../../../core/services/app-presupuestos.service";
import {ClsObjGenerico} from 'src/app/clases-pu/util/cls-obj-generico';
import {ClsObjCrudCatalogos} from "../../../clases-pu/02-catalogos/cls-obj-crud-catalogos";
import {ClsObjConfiguracionGrid} from "../../../clases-pu/util/cls-obj-configuracion-grid";
import {INeodataMenu} from "../../../core/models/interfaces/generico-interface";
import {ClsCalendario, ClsCalendarioFecha} from "../../../core/models/cls-catalogos";
import {EnumNombresGrids} from "../../../core/models/enum/enum-nombres-grids";
import {ClsUtil} from "../../../util/cls-util";
import {EnumMasOpciones} from "../../../core/models/enum/enum-mas-opciones";
import {Workbook, WorkbookFormat} from 'igniteui-angular-excel';
import {ExcelUtility} from "../../../util/excel-utility";
import {EnumMCGenerales} from "../../../core/models/enum/enum-menu-contextual";
import {PasteHandlerNeodataDirective} from "../../../core/directivas/paste-handler-neodata.directive";
import {EnumTresPuntos} from "../../../core/models/enum/enum-tres-puntos";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UppercaseDirective} from "../../../core/directivas/uppercase.directive";

@Component({
  selector: 'app-calendarios',
  templateUrl: './calendarios.component.html',
  styleUrls: ['./calendarios.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    IGX_SPLITTER_DIRECTIVES,
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    IgxRippleModule,
    IgxRippleDirective,
    MasOpcionesGridComponent,
    ContextMenuGenericoComponent,
    PasteHandlerNeodataDirective,
    ReactiveFormsModule,
    UppercaseDirective,
    FormsModule,
    IgxTextSelectionDirective,
    IgxFocusDirective,
    IgxSplitterComponent,
    IgxSplitterPaneComponent,
    IgxInputGroupComponent
  ]
})
export class CalendariosComponent extends ClsConfig implements OnInit, AfterViewInit {
  private tipoMsg = inject(TipoMensajesService);
  private excelExportService = inject(IgxExcelExporterService);
  private infPpto = inject(AppPresupuestosService);

  @ViewChild('gridCalendario', {read: IgxGridComponent, static: true})
  public gridCalendario: IgxGridComponent;

  @ViewChild('gridFecha', {read: IgxGridComponent, static: true})
  public gridFecha: IgxGridComponent;

  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;

  public errorAlCargar: boolean;
  public activarBotones = false;

  public dataGridCalendario: ClsCalendario[];
  public calendarioSeleccionado: ClsCalendario;
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();

  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  // CONFIGGRIDS:
  @ViewChild(IgxGridStateDirective, {static: true}) public stateCalendario;
  @ViewChild(IgxGridStateDirective, {static: true}) public stateFecha;
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';
  // Grid Layout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };

  // mostrar actionStrip
  public showActionStrip = true;
  public showActionStripFecha = true;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridCalendario.data = [];
    this.gridFecha.data = [];
  }

  public ngAfterViewInit() {
    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Calendario, true, this.stateCalendario.getState(true), '', this.clicked);
    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Fechas, true, this.stateFecha.getState(true), '', this.clicked);

    const stateCalendario = this.mObjConfigGrids.initGridState(EnumNombresGrids.Calendario);
    if (!ClsUtil.esNulo(stateCalendario[0])) {
      this.stateCalendario.setState(stateCalendario[0]);
    }

    const stateFecha = this.mObjConfigGrids.initGridState(EnumNombresGrids.Fechas);
    if (!ClsUtil.esNulo(stateFecha[0])) {
      this.stateFecha.setState(stateFecha[0]);
    }

    // el ajustar funciona por componente, osea que a los dos grids se ajusta el texto, independiente desde que grid haga la acción
    this.clicked = stateCalendario[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
    // seleccionar celda descripcion del row 0 por default
    this.gridCalendario.setSelection({rowStart: 0, rowEnd: 0, columnStart: 'DescripcionCalendario', columnEnd: 'DescripcionCalendario'});
  }

  public async cargarCalendarios() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
      this.mObjCRUDCatalogos.dataCatalogo = [];
      this.dataGridCalendario = [];
      await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarCalendarios2021');
      // Mapear los calendarios obtenidos
      this.dataGridCalendario = this.mObjCRUDCatalogos.dataCatalogo.map((cal: ClsCalendario) => {
        const fechas: ClsCalendarioFecha[] = [];

        // Validar y procesar JsonFechas
        if (cal.JsonFechas?.trim()) {
          ClsUtil.splitEnter(cal.JsonFechas)
            .filter(linea => linea.trim().length > 0)
            .map(enter => {
              const [fechaStr, descripcion] = ClsUtil.splitTabs(enter);
              const fecha = fechaStr ? new Date(fechaStr) : null;

              const fechaObj = new ClsCalendarioFecha();
              fechaObj.IdFecha = ClsUtil.generarIDNumber();
              fechaObj.FechaNoLaborable = fecha;
              fechaObj.Descripcion = descripcion?.trim() ?? '';

              fechas.push(fechaObj);
            })
        }

        return {
          IdCalendario: cal.IdCalendario,
          CodigoCalendario: cal.CodigoCalendario,
          DescripcionCalendario: cal.DescripcionCalendario,
          Lunes: cal.Lunes,
          Martes: cal.Martes,
          Miercoles: cal.Miercoles,
          Jueves: cal.Jueves,
          Viernes: cal.Viernes,
          Sabado: cal.Sabado,
          Domingo: cal.Domingo,
          Predeterminado: cal.Predeterminado,
          JsonFechas: cal.JsonFechas,
          Fechas: fechas
        } as ClsCalendario
      });

      // Asignar al grid principal
      this.gridCalendario.data = this.dataGridCalendario;
      // Seleccionar el primer calendario disponible
      const primerCalendario = this.dataGridCalendario[0];
      this.calendarioSeleccionado = primerCalendario ?? null;
      // Asignar al grid de fechas
      this.gridFecha.data = this.calendarioSeleccionado?.Fechas ?? [];
      // Cerrar diálogo de espera
      this.tipoMsg.cerrarWaitDialog();
      this.errorAlCargar = false;
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.errorAlCargar = true;
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public clearInput(input: HTMLInputElement, gridType: string) {
    input.value = '';
    this.getGrid(gridType).clearFilter();
  }

  public filterInput(filtro: string, gridType: string) {
    const grid = this.getGrid(gridType);
    grid.filteringLogic = FilteringLogic.Or;
    grid.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public rowEditEnter() {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  public rowEditEnterFecha() {
    this.showActionStripFecha = false;
  }

  public rowEditExitFecha() {
    this.showActionStripFecha = true;
  }

  public isDeleted(rowContext: RowType) {
    return rowContext && rowContext.deleted;
  }

  public accionStripRow(rowContext: RowType, accion: number, gridType: string) {
    try {
      const grid = this.getGrid(gridType);
      switch (accion) {
        case 1:
          grid.beginAddRowByIndex(rowContext.index);
          break;
        case 2:
          if (gridType === 'calendario') {
            this.tipoMsg.mostrarQuestion(async (resp: boolean) => {
              if (resp) {
                await this.eliminarCalendario(rowContext);
                // groupingFlatResult tiene la data actualizada, y obtenemos el el primer registro
                const nuevoCalendario = grid.groupingFlatResult?.[0];
                if (this.calendarioSeleccionado) {
                  this.calendarioSeleccionado = nuevoCalendario;
                  // seteamos las fechas del calendario seleccionado
                  this.gridFecha.data = nuevoCalendario.Fechas;
                }
                // limpiamos celdas selecionada
                grid.clearCellSelection();
                // seleccionamos la celda de la primer fila
                grid.setSelection({rowStart: 0, rowEnd: 0, columnStart: 'Descripcion', columnEnd: 'Descripcion'});
                this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
                this.tipoMsg.cerrarWaitDialog();
              }
            }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.CodigoCalendario));
            break;
          }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onSelectionDropDown(opcion: string, gridType: string) {
    try {
      const grid = this.getGrid(gridType);
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const nombrearchivo: string = this.mObjGenerico.getTranslationsGetCatalogos(gridType === 'calendario' ? 'MENSAJES.GRALS.CALENDARIOS' : 'MENSAJES.GRALS.FECHAS');
          const sms = await ClsUtil.exportarDatos(grid, nombrearchivo, this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, grid.selectedRows.length));
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarCalendarios();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          grid.clearFilter();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async exportarTodo() {
    try {
      if (this.gridFecha.data.length === 0) {
        throw new Error('MENSAJES.ALERT.NO_HAY_DATOS_EXPORTAR');
      }
      // inicializar instancia del libro
      const workbook: Workbook = new Workbook(WorkbookFormat.Excel2007);
      // verificamos si selecciono algunos calendarios para ser exportados
      let dataExportar: ClsCalendario[] = this.gridCalendario.selectedRows.map((id) => this.gridCalendario.getRowByKey(id).data);
      // en caso de no haber seleccionado algun calendario, se exporta todo
      if (dataExportar.length === 0) {
        dataExportar = this.gridCalendario.data;
      }
      // iteramos los calendarios con sus dias no laborables
      dataExportar.forEach((calendario: ClsCalendario) => {
        // inicializamos hoja por calendario
        const sheet = workbook.worksheets().add(calendario.CodigoCalendario);
        sheet.defaultColumnWidth = 220 * 20;

        sheet.getCell('A1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_CALENDARIO');
        sheet.getCell('B1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_DESCRIPCION');
        sheet.getCell('C1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_LUNES');
        sheet.getCell('D1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_MARTES');
        sheet.getCell('E1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_MIERCOLES');
        sheet.getCell('F1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_JUEVES');
        sheet.getCell('G1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_VIERNES');
        sheet.getCell('H1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_SABADO');
        sheet.getCell('I1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_DOMINGO');
        sheet.getCell('J1').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIOS.COL_PREDETERMINADO');

        sheet.getCell('A2').value = calendario.CodigoCalendario;
        sheet.getCell('B2').value = calendario.DescripcionCalendario;
        sheet.getCell('C2').value = calendario.Lunes;
        sheet.getCell('D2').value = calendario.Martes;
        sheet.getCell('E2').value = calendario.Miercoles;
        sheet.getCell('F2').value = calendario.Jueves;
        sheet.getCell('G2').value = calendario.Viernes;
        sheet.getCell('H2').value = calendario.Sabado;
        sheet.getCell('I2').value = calendario.Domingo;
        sheet.getCell('J2').value = calendario.Predeterminado;

        sheet.getCell('A4').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIO_FECHAS.COL_FECHA_NO_LABORABLE');
        sheet.getCell('B4').value = this.mObjGenerico.getTranslationsGetCatalogos('GRIDS.CALENDARIO_FECHAS.COL_DESCRIPCION');

        calendario.Fechas.forEach((fecha, index) => {
          sheet.getCell(`A${index + 5}`).value = fecha.FechaNoLaborable;
          sheet.getCell(`B${index + 5}`).value = fecha.Descripcion;
        });
      });

      await ExcelUtility.save(workbook, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.CALENDARIOS'));
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public onSelectionCalendario(event: IGridCellEventArgs) {
    try {
      const data: ClsCalendario = event.cell.row.data;
      // validamos si hay commit pendientes en el grid de fechas
      if (this.hasTransactions) {
        this.gridCalendario.clearCellSelection(); // limpiar seleccion
        // get row del calendario seleccionado
        const seleccion = this.gridCalendario.getRowByKey(this.calendarioSeleccionado.IdCalendario);
        this.gridCalendario.setSelection({
          rowStart: seleccion.index,
          rowEnd: seleccion.index,
          columnStart: 'Descripcion',
          columnEnd: 'Descripcion'
        });
        const cambiosGral = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_GRAL');
        const fechasNoLaborables = this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO_FECHAS.COL_FECHA_NO_LABORABLE');
        throw new Error(cambiosGral.replace('{0}', fechasNoLaborables));
      } else {
        this.gridFecha.rowEditable = false; // desactivamos la edicion, por si estaba en edicion pero no tenia commit pendientes
        this.gridFecha.data = data.Fechas; // seteamos las fechas del calendario seleccionado
        this.calendarioSeleccionado = data;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de toda la fila se cancela la edicion y se manda mensaje de que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarCalendario(calendario: IGridEditEventArgs) {
    const valor: ClsCalendario = calendario.newValue;
    calendario.cancel = this.esValido(valor, calendario, calendario.isAddRow);
  }

  // en este caso se pasa el valor de la ciudad, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValido(calendario: ClsCalendario, cal: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(calendario.CodigoCalendario)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CALENDARIOS.COL_CALENDARIO')));
      return true;
    }

    if (ClsUtil.esNulo(calendario.DescripcionCalendario)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CALENDARIOS.COL_DESCRIPCION')));
      return true;
    }

    // validar cuando se agrega nuevo registro
    if (isAddRow) {
      if (this.dataGridCalendario.findIndex(calendarios => calendarios.CodigoCalendario === calendario.CodigoCalendario) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(calendario.CodigoCalendario));
        return true;
      }
    } else {
      if (calendario.CodigoCalendario !== cal.oldValue.CodigoCalendario) {
        if (this.dataGridCalendario.findIndex(calendarios => calendarios.CodigoCalendario === calendario.CodigoCalendario) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(calendario.CodigoCalendario));
          return true;
        }
      }
    }

    const dias = ['Lunes', 'Martes', 'Miercoles', 'Jueves', 'Viernes', 'Sabado', 'Domingo'] as const;
    const tieneDiaLaboral = dias.some(dia => (calendario as ClsCalendario)[dia]);
    if (!tieneDiaLaboral) {
      this.tipoMsg.mostrarMsg('MENSAJES.ALERT.CAL_1_DIA_LABORAL');
      return true;
    }

    // validar que no exista ya un calendario predeterminado
    const calendarioPredeterminado = this.dataGridCalendario.find(c => c.Predeterminado);
    if (calendarioPredeterminado && calendario.Predeterminado) {
      this.tipoMsg.mostrarMsg('MENSAJES.ALERT.CAL_1_PREDETERMINADO');
      return true;
    }

    return false;
  }

  public async addUpdateCalendario(calendario: IGridEditDoneEventArgs) {
    const newValor: ClsCalendario = calendario.newValue;
    const oldValor: ClsCalendario = calendario.oldValue;
    if (calendario.isAddRow) {
      await this.agregarModificarCalendario(newValor, oldValor, calendario.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.Calendarios)) {
        await this.agregarModificarCalendario(newValor, oldValor, calendario.isAddRow);
      }
    }
  }

  private async agregarModificarCalendario(newCalendario: ClsCalendario, oldCalendario: ClsCalendario, isAddRow: boolean) {
    try {
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      const id: bigint = await this.objCalendario(isAddRow, newCalendario);
      if (isAddRow) {
        newCalendario.IdCalendario = id;
      }
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateCiudades(newCalendario, oldCalendario, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  private async objCalendario(isAddRow: boolean, calendario: ClsCalendario) {
    const objCatalogo: ClsCalendario = new ClsCalendario();
    try {
      objCatalogo.IdCalendario = isAddRow ? ClsUtil.parseJSONBig(0) : calendario.IdCalendario;
      objCatalogo.CodigoCalendario = calendario.CodigoCalendario.toUpperCase();
      objCatalogo.DescripcionCalendario = calendario.DescripcionCalendario;
      objCatalogo.Lunes = calendario.Lunes;
      objCatalogo.Martes = calendario.Martes;
      objCatalogo.Miercoles = calendario.Miercoles;
      objCatalogo.Jueves = calendario.Jueves;
      objCatalogo.Viernes = calendario.Viernes;
      objCatalogo.Sabado = calendario.Sabado;
      objCatalogo.Domingo = calendario.Domingo;
      objCatalogo.Predeterminado = calendario.Predeterminado;
      objCatalogo.JsonFechas = calendario.JsonFechas;
      const respuesta: bigint = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'CalendariosRegistraActualiza2021');
      return respuesta;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateCiudades(newCalendario: ClsCalendario, oldCalendario: ClsCalendario, isAddRow: boolean) {
    if (isAddRow) {
      this.gridCalendario.deleteRowById(newCalendario.IdCalendario);
    } else {
      this.gridCalendario.updateRow(oldCalendario, oldCalendario.IdCalendario);
    }
  }

  private async eliminarCalendario(rowContext: RowType) {
    const calendario: ClsCalendario = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(calendario.IdCalendario, 'EliminarCalendrios2021');
      this.gridCalendario.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de toda la fila se cancela la edicion y se manda mensaje de que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarFechas(fechas: IGridEditEventArgs) {
    const valor: ClsCalendarioFecha = fechas.newValue;
    fechas.cancel = this.esValidoFechas(valor, fechas, fechas.isAddRow);
  }

  // en este caso se pasa el valor de la ciudad, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValidoFechas(fecha: ClsCalendarioFecha, date: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(fecha.FechaNoLaborable)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CALENDARIO_FECHAS.COL_FECHA_NO_LABORABLE')));
      return true;
    }

    if (ClsUtil.esNulo(fecha.Descripcion)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CALENDARIO_FECHAS.COL_DESCRIPCION')));
      return true;
    }

    // validar cuando se agrega nuevo registro
    if (isAddRow) {
      if (this.gridFecha.groupingFlatResult.findIndex(fecha2 => fecha2.FechaNoLaborable.getTime() === fecha.FechaNoLaborable.getTime()) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(ClsUtil.formatoFechaManualPipe(fecha.FechaNoLaborable, 'dd/MM/yyyy')));
        return true;
      }
    } else {
      if (fecha.FechaNoLaborable.getTime() !== date.oldValue.FechaNoLaborable.getTime()) {
        if (this.gridFecha.groupingFlatResult.findIndex(fecha2 => fecha2.FechaNoLaborable.getTime() === fecha.FechaNoLaborable.getTime()) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(ClsUtil.formatoFechaManualPipe(fecha.FechaNoLaborable, 'dd/MM/yyyy')));
          return true;
        }
      }
    }
    return false;
  }

  public abrirEdicion() {
    try {
      this.gridFecha.rowEditable = !this.gridFecha.rowEditable;
      // si no tiene ningun row, activamos por default para que la captura sea mas rapida
      if (this.gridFecha.data.length === 0) {
        this.gridFecha.beginAddRowByIndex(0);
      }
    } catch (e) {
      this.gridFecha.rowEditable = false;
      this.tipoMsg.mostrarMsg(e.message);
    }
  }

  public cancelarEdicion() {
    try {
      const cambiosGral = this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_GRAL');
      const fechasNoLaborables = this.mObjGenerico.getTranslationsSubject('GRIDS.CALENDARIO_FECHAS.COL_FECHA_NO_LABORABLE');
      const mensaje: string = this.hasTransactions ? cambiosGral.replace('{0}', fechasNoLaborables) : 'MENSAJES.ALERT.CAMBIOS_SIN_GUARDAR_CONCEPTOS2';
      this.tipoMsg.mostrarQuestion((resp: boolean) => {
        if (resp) {
          this.gridFecha.rowEditable = !this.gridFecha.rowEditable;
          this.gridFecha.transactions.clear();
        }
      }, mensaje);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async commit() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      this.gridFecha.transactions.commit(this.gridFecha.data);
      // Construir el JSON de fechas manualmente
      this.calendarioSeleccionado.JsonFechas = this.gridFecha.data
        .map((row: ClsCalendarioFecha) => {
          const fechaStr = row.FechaNoLaborable.toString();
          return `${fechaStr}${ClsUtil.TAB}${row.Descripcion}${ClsUtil.ENTER}`;
        }).join('');
      await this.objCalendario(false, this.calendarioSeleccionado);
      this.gridFecha.rowEditable = false;
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public undo() {
    this.gridFecha.transactions.undo();
  }

  public redo() {
    this.gridFecha.transactions.redo();
  }

  public discard() {
    try {
      this.tipoMsg.mostrarQuestion((resp: boolean) => {
        if (resp) {
          this.gridFecha.transactions.clear();
        }
      }, 'MENSAJES.QUESTION.CANCELAR_CAMBIOS');
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public marcarTodoBorrar() {
    this.gridFecha.groupingFlatResult.forEach((value: ClsCalendarioFecha) => {
      // borramos los que no lo estan
      if (!this.gridFecha.getRowByKey(value.IdFecha).deleted) {
        this.gridFecha.deleteRowById(value.IdFecha);
      }
    });
  }

  public get hasTransactions(): boolean {
    return this.gridFecha.transactions.getAggregatedChanges(false).length > 0;
  }

  private getGrid(gridType: string): IgxGridComponent {
    return gridType === 'calendario' ? this.gridCalendario : this.gridFecha;
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public async accionSeleccionada(evt: any) {
    try {
      // Si el objeto del evento contiene IdFecha, entonces es el gridFecha
      const gridType = 'IdFecha' in evt.dataSelected.rowData ? 'fecha' : 'calendario';
      const grid = this.getGrid(gridType);
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.Copiar:
          await this.copiarData(grid, gridType);
          break;
        // case EnumMCGenerales.Pegar:
        //   let data: any = await navigator.clipboard.readText().then((data2) => data2);
        //   data = this.pasteHandlerNeo.processData(data);
        //   await this.datosPegadosDesdeExcel(data, grid, gridType);
        //   break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          // aqui ver de manejar el guardado de los layouts pero de manera individual
          const state = (gridType === 'calendario') ? this.stateCalendario.getState(true) : this.stateFecha.getState(true);
          const enumNomGrid: string = gridType === 'calendario' ? EnumNombresGrids.Calendario : EnumNombresGrids.Fechas;
          this.mObjConfigGrids.saveGridState(enumNomGrid, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid(gridType);
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid(gridType: string) {
    const stateDefault = (gridType === 'calendario') ? this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Calendario)
      : this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Fechas);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      (gridType === 'calendario') ? this.stateCalendario.setState(stateDefault[0]) : this.stateFecha.setState(stateDefault[0]);
    }

    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public async customKeydown(eventArgs: any, grid: IgxGridComponent, gridType: string) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData(grid, gridType);
    }
  }

  public async copiarData(grid: IgxGridComponent, gridType: string) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const pk  = gridType === 'calendario' ? 'IdCalendario' : 'IdFecha';
      const msg: string = await ClsUtil.copiarDatosGrids(grid, pk, this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public handleRowSelection(grid: IgxGridComponent) {
    grid.nativeElement.focus();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridCalendario.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridCalendario.getRowData(rowSeleccionados[0]);
      this.gridCalendario.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }


  // public async datosPegadosDesdeExcel(datosPegado: any[], grid: IgxGridComponent, gridType: 'calendario' | 'fecha') {
  //   try {
  //     this.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
  //
  //     let arrayDatos: ClsCalendario[] | ClsCalendariosFechas = [];
  //     let dataDetalle: ClsColDetallePegado[];
  //
  //
  //     const columnas = grid.columnList.map(col => col.header);
  //     const fields = grid.columnList.map(col => col.field);
  //
  //     this.mObjCopiado.columnasRequeridas = columnas;
  //
  //     if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
  //       let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
  //       datos = (gridType == 'calendario') ? this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.Calendario)
  //         : this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.Fechas);
  //
  //       dataDetalle = (gridType == 'calendario') ? this.mObjPegado.verificarDetallePegado(datos, columnas, this.mObjCopiado.columnasRequeridas, EnumNombresGrids.Calendario, this.mObjGenerico)
  //         : this.mObjPegado.verificarDetallePegado(datos, columnas, this.mObjCopiado.columnasRequeridas, EnumNombresGrids.Fechas, this.mObjGenerico);
  //
  //       if (dataDetalle.length > 0) {
  //         const vtnGenerico = this.hostLocal.crearComponente(VtnGenericaComponent);
  //         vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
  //         const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
  //         vtnDiferencia.dataDetalle = dataDetalle;
  //         vtnDiferencia.open();
  //       } else {
  //         datos.forEach(dato => {
  //
  //           // objData puede ser de tipo ClsCalendario o ClsCalendarioFecha
  //           const objData = columnas.map((col, index) => dato[col] ?? '');
  //
  //           const resp: any = (gridType == 'calendario') ? this.mObjCRUDCatalogos.crearObjCatalogos(this.dataCalendario, objData, columnas, EnumTresPuntos.Calendarios, this.mObjGenerico)
  //             : this.mObjCRUDCatalogos.crearObjCatalogos(this.dataGridFecha, objData, columnas, EnumTresPuntos.Fechas, this.mObjGenerico);
  //
  //           if (!ClsUtil.esNulo(resp.esNuevo)) {
  //             if (resp.esNuevo) {
  //               arrayDatos.push(resp.obj);
  //             } else {
  //               objData.forEach((value, index) => {
  //                 if (value !== undefined) {
  //                   (gridType == 'calendario') ? this.gridCalendario.updateCell(value, resp.obj.IdCalendario, fields[index])
  //                     : grid.updateCell(value, resp.obj.IdFecha, fields[index]);
  //                 }
  //               });
  //               arrayDatos.push(resp.obj);
  //             }
  //           }
  //         });
  //         if (arrayDatos.length > 0) {
  //           // aqui tiene que ir la logica de backend
  //           // const respuesta: any = await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayEmpresas, 'EmpresasRegistraActualizaCod', false);
  //           // filtro los registros con id 0
  //           // arrayEmpresas = arrayEmpresas.filter(value => value.IdEmpresa === BigInt(0));
  //           // iteramos la respuesta para ir asignando los ids para los registros nuevos
  //           // const key: string[] = Object.keys(respuesta);
  //           // key.forEach(x => {
  //           //   const emp: ClsEmpresas = arrayEmpresas.find(value1 => value1.Empresa === x);
  //           //   if (!ClsUtil.esNulo(emp)) {
  //           //     emp.IdEmpresa = ClsUtil.bigintX(respuesta[x]);
  //           //     this.gridEmpresas.addRow(emp);
  //           //   }
  //           // })
  //           arrayDatos.forEach((value: ClsCalendario | ClsCalendarioFecha) => {
  //             if (gridType === 'calendario' && 'IdCalendario' in value) {
  //               if (value.IdCalendario === 0) {
  //                 value.IdCalendario = this.gridCalendario.data.length + 1;
  //                 this.gridCalendario.addRow(value);
  //               } else {
  //                 this.gridCalendario.updateRow(value.IdCalendario, value);
  //               }
  //             } else if (gridType === 'fecha' && 'IdFecha' in value) {
  //               if (value.IdFecha === 0) {
  //                 value.IdFecha = this.gridFecha.data.length + this.gridFecha.transactions.getAggregatedChanges(true).filter(t => t.type === 'add').length + 1;
  //                 this.gridFecha.addRow(value);
  //               } else {
  //                 this.gridFecha.updateRow(value.IdFecha, value);
  //               }
  //             }
  //           });
  //         }
  //       }
  //     }
  //   } catch (e) {
  //     this.mostrarMsg(e.message);
  //   } finally {
  //     this.cerrarWaitDialog();
  //   }
  // }
}
